import { Helmet } from 'react-helmet-async'

/**
 * Holding screen for Batch 1 — proves the deploy and establishes the
 * aesthetic. The chat prototype replaces this in Batch 6.
 */
export default function App() {
  return (
    <>
      <Helmet>
        <html lang="en-GB" />
        <title>Trewbond</title>
      </Helmet>

      <main className="relative flex min-h-dvh items-center justify-center overflow-hidden px-6">
        {/* The lamp — a soft brass glow, low and warm */}
        <div
          aria-hidden
          className="pointer-events-none absolute left-1/2 top-1/2 h-[40rem] w-[40rem] -translate-x-1/2 -translate-y-1/2 rounded-full opacity-[0.07] blur-[120px]"
          style={{ background: 'rgb(var(--color-brass))' }}
        />

        <div className="relative flex flex-col items-center text-center">
          <p
            className="mb-6 text-xs uppercase tracking-[0.35em] text-text-faint"
            style={{ animation: 'rise 0.7s ease-out both' }}
          >
            The faithful bond
          </p>

          <h1
            className="font-display text-6xl font-medium tracking-tight text-text-primary sm:text-7xl"
            style={{ animation: 'rise 0.7s ease-out 0.1s both' }}
          >
            Trewbond
          </h1>

          <div
            className="my-7 h-px w-16 bg-brass/60"
            style={{ animation: 'rise 0.7s ease-out 0.2s both' }}
          />

          <p
            className="max-w-sm text-balance text-lg leading-relaxed text-text-muted"
            style={{ animation: 'rise 0.7s ease-out 0.3s both' }}
          >
            Your business partner. On your side — and no one else&rsquo;s.
          </p>

          <p
            className="mt-12 text-sm text-text-faint"
            style={{ animation: 'rise 0.7s ease-out 0.5s both' }}
          >
            Building.
          </p>
        </div>

        <style>{`
          @keyframes rise {
            from { opacity: 0; transform: translateY(12px); }
            to   { opacity: 1; transform: translateY(0); }
          }
          @media (prefers-reduced-motion: reduce) {
            * { animation: none !important; }
          }
        `}</style>
      </main>
    </>
  )
}
